import { heroEquipment } from "../HeroEquipment";

export const piraci = {
  heroes: {
    "Kapitan piratów": {
      id: 0,
      startingEquipment: ["Sztylet", "Rapier"],
      cost: 55,
      number: 1,
      equipmentList: heroEquipment["Piraci z Sartosy"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 4, 4, 3, 3, 2, 4, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Dowodzenie", "Dowódca"],
      exp: 20,
      skills: [0, 1, 2, 3, 4, 5],
    },
    Czarownik: {
      id: 1,
      startingEquipment: ["Sztylet", "Kostur"],
      cost: 35,
      number: 1,
      equipmentList: heroEquipment["Piraci z Sartosy"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Guślarstwo", "Mag (Kolegia Magii)"],
      exp: 12,
      skills: [2, 4, 5],
    },
    "Kapłan Mananna": {
      id: 2,
      startingEquipment: ["Sztylet", "Trójząb"],
      cost: 35,
      number: 1,
      equipmentList: heroEquipment["Piraci z Sartosy"].Kapłan,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Czarostwo","Duchowny (modlitwy do Mananna)","Modlitwa","Pogarda","Rozproszenie magii (2)"],
      exp: 12,
      skills: [0, 2, 3, 5],
    },
    Bosman: {
      id: 3,
      startingEquipment: ["Sztylet", "Buława/Maczuga/Młot bojowy"],
      cost: 25,
      number: 1,
      equipmentList: heroEquipment["Piraci z Sartosy"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 4, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Podoficer"],
      exp: 8,
      skills: [0, 3, 4, 5],
    },
    "Łowca niewolników": {
      id: 4,
      startingEquipment: ["Sztylet", "Łapacz"],
      cost: 25,
      number: 1,
      equipmentList: heroEquipment["Piraci z Sartosy"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Handlarz niewolników", "Żertwa"],
      exp: 8,
      skills: [0, 3, 5],
    },
    Mat: {
      id: 5,
      startingEquipment: ["Sztylet"],
      cost: 15,
      number: 1,
      equipmentList: heroEquipment["Piraci z Sartosy"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 2, 2, 3, 3, 1, 3, 1, 6],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Przyboczny"],
      exp: 0,
      skills: [0, 1, 4, 5],
    },
    Niewolnik: {
      id: 6,
      startingEquipment: ["Broń improwizowana"],
      cost: 10,
      number: 15,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [4, 2, 2, 3, 3, 1, 3, 1, 2],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Mięso armatnie", "Niewolnik", "Rozmiar rzondzi"],
    },
    Pirat: {
      id: 6,
      startingEquipment: ["Sztylet"],
      cost: 20,
      number: 15,
      equipmentList: heroEquipment["Piraci z Sartosy"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Chorążowie & sygnaliści","Drużyna ciężkich broni (harpun, ołowiomiotacz)","Drużyna obsługi"],
    },
    "Drużyna ciężkich broni": {
      id: 7,
      startingEquipment: ["Sztylet", "Buława/Maczuga/Młot bojowy"],
      cost: 40,
      number: 2,
      equipmentList: heroEquipment["Piraci z Sartosy"].Ciężcy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Drużyna ciężkich broni", "Drużyna wsparcia"],
    },
    "Żołnierz Okrętowy": {
      id: 8,
      startingEquipment: ["Sztylet", "Miecz"],
      cost: 30,
      number: 5,
      equipmentList: heroEquipment["Piraci z Sartosy"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 4, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Drużyna wsparcia", "Szermierz"],
    },
    Przepatrywacz: {
      id: 9,
      startingEquipment: [
        "Sztylet",
        "Miecz",
        "Włócznia",
        "Koń bojowy",
        "Siodło & uprząż",
      ],
      cost: 70,
      number: 3,
      equipmentList: heroEquipment["Piraci z Sartosy"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
        "Koń bojowy": [8, 3, 0, 3, "-", "-", 3, 1, 5],
      },
      rules: ["Kawalerzysta", "Lekka jazda", "Ranger", "Zwiadowca"],
    },
    Ogr: {
      id: 10,
      startingEquipment: ["Maczuga ogrów"],
      cost: 160,
      number: 1,
      equipmentList: heroEquipment["Piraci z Sartosy"].Ogr,
      type: "Stronnik",
      stats: {
        Początkowa: [6, 3, 2, 4, 4, 3, 2, 2, 7],
        Maksymalna: [6, 6, 5, 5, 5, 5, 6, 5, 9],
      },
      rules: [
        "Bycza szarża",
        "Duży cel",
        "Głód trzewi",
        "Oznakowany gnoblar (gnoblar-uwaga)",
        "Przepastne trzewia",
        "Strach",
        "Tempy",
        "Wielkolud",
      ],
    },
    Więźniarka: {
      id: 11,
      startingEquipment: [],
      cost: 175,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Powóz: ["-", "-", "-", 4, 8, 8, "-", "-", "-"],
        Koń: [8, 3, 0, 3, "-", "-", 3, 1, 5],
        "Koń ": [8, 3, 0, 3, "-", "-", 3, 1, 5],
      },
      rules: ["Duży cel", "Machina wojenna", "Powóz", "Więźniarka"],
    },
    Rydwan: {
      id: 12,
      startingEquipment: [],
      cost: 125,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Rydwan: ["-", "-", "-", 5, 5, 8, "-", "-", "-"],
        Koń: [8, 3, 0, 3, "-", "-", 3, 1, 5],
        "Koń ": [8, 3, 0, 3, "-", "-", 3, 1, 5],
      },
      rules: ["Duży cel", "Machina wojenna", "Rydwan"],
    },
  },
  limit: 500,
  minModels: 3,
  maxModels: 15,
  name: "Piraci z Sartosy",
  nature: "Zła",
  armyRules: ["Kontakty handlowe (3)", "Rozrzutność"],
  mercenaries: [
    "Balistyk",
    "Bombardier",
    "Gladiator",
    "Kartograf",
    "Kupiec",
    "Łowca nagród",
    "Magus",
    "Medyk",
    "Minstrel",
    "Miotacz ołowiu",
    "Ochroniarz",
    "Ordynans",
    "Pogromca Trolli",
    "Poszukiwacz złota",
    "Rozbójnik",
    "Rycerz najemny",
    "Skryba",
    "Strażnik dróg",
    "Szczurołap",
    "Szpieg",
    "Tileański kusznik",
    "Trefniś",
    "Woźnica",
    "Wróżbita",
    "Złodziej",
    "Zwadźca",
    "Zwiadowca",
  ],
};
